import React from 'react';
import PosContents from './PosContents';

/**
 * POS 메인 페이지 컴포넌트
 */
const Pos = () => {
  return (
    <div className="row align-items-top">
      <PosContents />
    </div>
  );
};

export default Pos;
